import ResourceUploadSection, { ResourceUploadSectionProps } from './ResourceUploadSection';

export type { ResourceUploadSectionProps };
export default ResourceUploadSection;
